import { useMemo } from 'react';

import { PERIOD_PRESETS } from '../constants';

export function ensurePeriodType(filters) {
  const periodType = PERIOD_PRESETS.find(({ value }) => {
    return value.every(
      (val, index) => val === filters.registrationPeriod[index]
    );
  })?.key?.[0];

  return {
    ...filters,
    ...(periodType ? { periodType } : null),
  };
}

export const useFiltersWithPeriodType = (filters) => {
  return useMemo(() => {
    return ensurePeriodType(filters);
  }, [filters]);
};
